import { roleToText } from 'src/legacy_modules/text'
import type { components } from 'src/lib/api-client/schema.gen'

import { Role } from './entity'

const roleOptions: Array<{ name: string; value: Role }> = [
  Role.Dr,
  Role.CRC,
  Role.DM,
  Role.CRA,
  Role.Viewer,
].map(r => ({
  name: roleToText(r),
  value: r,
}))

export const filterRoleOptionsByFeatureChannel = (
  featureChannel: components['schemas']['input.FeatureChannel'],
) => {
  return roleOptions.filter(roleOption => {
    return roleOption.value !== Role.Viewer || featureChannel === 'Canary'
  })
}

export const shouldSelectHospital = (role: Role) => {
  return [Role.Dr, Role.CRC, Role.CRA, Role.Viewer].includes(role)
}
